export default "__VITE_ASSET__pADEGV0e5Qot5ZhzD_GrLg__";